import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpResponse,
} from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { tap, catchError, map } from 'rxjs/operators';
import { AuthenticationService } from '@app/auth';
import { GlobalEventsService } from '@app/global-events.service';

@Injectable()
export class TermsNotAcceptedInterceptor implements HttpInterceptor {
  constructor(private globalEventsService: GlobalEventsService) {}

  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler,
  ): Observable<HttpEvent<unknown>> {
    return next.handle(request);
  }
}
